import { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

type Props = {
  search: string;
  onSearchChange: (value: string) => void;
  filterPro: boolean | null;
  onFilterProChange: (value: boolean | null) => void;
  filterRole: 'admin' | 'editor' | null;
  onFilterRoleChange: (value: 'admin' | 'editor' | null) => void;
  pageSize: number;
  onPageSizeChange: (value: number) => void;
};

export function UserFilters(props: Props) {
  const {
    search,
    onSearchChange,
    filterPro,
    onFilterProChange,
    filterRole,
    onFilterRoleChange,
    pageSize,
    onPageSizeChange,
  } = props;

  // Debounced search
  const [localSearch, setLocalSearch] = useState(search);

  useEffect(() => {
    const id = setTimeout(() => {
      onSearchChange(localSearch);
    }, 300);
    return () => clearTimeout(id);
  }, [localSearch, onSearchChange]);

  return (
    <div className="flex flex-wrap gap-3 items-center">
      <Input
        type="text"
        placeholder="Search by email or name…"
        value={localSearch}
        onChange={e => setLocalSearch(e.target.value)}
        className="w-64"
      />

      <Select
        value={filterPro === null ? 'all' : filterPro ? 'pro' : 'free'}
        onValueChange={v => {
          if (v === 'all') onFilterProChange(null);
          else if (v === 'pro') onFilterProChange(true);
          else onFilterProChange(false);
        }}
      >
        <SelectTrigger className="w-[150px]">
          <SelectValue placeholder="All plans" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All plans</SelectItem>
          <SelectItem value="pro">Pro only</SelectItem>
          <SelectItem value="free">Free only</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={filterRole ?? 'all'}
        onValueChange={v => {
          if (v === 'all') {
            onFilterRoleChange(null);
          } else if (v === 'admin' || v === 'editor') {
            onFilterRoleChange(v);
          }
        }}
      >
        <SelectTrigger className="w-[150px]">
          <SelectValue placeholder="All roles" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All roles</SelectItem>
          <SelectItem value="admin">Admin</SelectItem>
          <SelectItem value="editor">Editor</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={pageSize.toString()}
        onValueChange={v => onPageSizeChange(Number(v))}
      >
        <SelectTrigger className="w-[130px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="25">25 / page</SelectItem>
          <SelectItem value="50">50 / page</SelectItem>
          <SelectItem value="100">100 / page</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
